<template>
  <div v-loading="loading" class="eval-competence">
    <search-input
      placeholder="Поиск по названию"
      style="width: 300px"
      v-model="filters.search"
      @change="filtersChanged"
    >
    </search-input>

    <categories-select
      style="margin-left: 20px"
      size="size"
      :multiple="false"
      v-model="filters.category_id"
      @change="filtersChanged"
    ></categories-select>

    <div class="competence-block">
      <el-table :data="competencies" border>
        <el-table-column prop="name" label="Название" width="500">
          <template v-slot="scope">
            <router-link
              class="table-router-link"
              :to="{ name: 'EvalCompetence', params: { id: scope.row.id } }"
              target="_blank"
            >
              {{ scope.row.name }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="Описание"></el-table-column>
        <el-table-column width="350" prop="category.name" label="Категория"></el-table-column>
        <el-table-column width="200" prop="indicators_count" label="Количество индикаторов">
          <template v-slot="scope">
              <span v-if="scope.row.indicators_count === 0">{{ scope.row.indicators_count }}</span>
              <el-button
                v-else
                size="mini"
                icon="fas fa-list-alt"
                @click="showIndicators(scope.row)"
              >
                 {{ scope.row.indicators_count }}
              </el-button>
          </template>
        </el-table-column>
        <el-table-column width="90" align="right">
          <template v-slot="scope">
            <el-popconfirm
              style="float:left"
              confirm-button-text='Да'
              cancel-button-text='нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите удалить компетенцию?"
              @confirm="deleteCompetence(scope.row)"
            >
              <el-button
                slot="reference"
                class="table-action-button"
                size="mini"
                round
                icon="far fa-trash-alt"
              >
              </el-button>
            </el-popconfirm>
            <el-button
              class="table-action-button"
              size="mini"
              round
              icon="fas fa-pen"
              @click="onEditCompetence(scope.row)"
            >
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <paginator
      :paginator.sync="paginator"
      use-router-query-param
      @page-changed="loadCompetencies"
    ></paginator>

    <indicators-table-list ref="showIndicators"></indicators-table-list>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import CategoriesSelect from "@/modules/evaluation/components/CategoriesSelect.vue";
import IndicatorsTableList from "@/modules/evaluation/components/indicator/IndicatorsTableList.vue";
import {paginator} from "@/mixins/paginator";

export default {
  name: "competencies-component",
  components: {IndicatorsTableList, Paginator, SearchInput, CategoriesSelect},
  mixins: [paginator],
  props: {
    onEditCompetence: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      competencies: [],
      filters: {},
    }
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  mounted() {
    this.loadCompetencies();
  },
  methods: {
    showIndicators(competence) {
      this.$refs.showIndicators.open(competence);
    },
    loadCompetencies() {
      this.loading = true;
      this.$api.evaluation.competenceSearch({
        ...this.filters,
        expand: ['category', 'indicators_count'].join(),
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.competencies = data.competencies;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteCompetence(competence) {
      this.loading = true;
      this.$api.evaluation.competenceDelete({
        ids: [competence.id]
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Компетенция успешно удалена'
          });
        })
        .finally(() => {
          this.loadCompetencies();
        })
    },
    filtersChanged() {
      this.loadCompetencies();
    }
  }
}
</script>

<style scoped lang="scss">
  .eval-competence {
    .competence-block {
      margin: 25px 0;
    }

    .table-router-link {
      text-decoration: none;
    }
  }
</style>